import { pickBy } from 'lodash';

const sanitiseCreateMenuGroupsPayload = (payload) => {
  const sanitisedValues = pickBy(payload, (value) => value !== undefined);

  return sanitisedValues;
};

export default sanitiseCreateMenuGroupsPayload;
